import script from "./RacingRightSidebarFixture.vue?vue&type=script&setup=true&lang=js"
export * from "./RacingRightSidebarFixture.vue?vue&type=script&setup=true&lang=js"

import "./RacingRightSidebarFixture.vue?vue&type=style&index=0&id=297e6f3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297e6f3d"]])

export default __exports__